export const ROUTE_GAME = "game";
export const ROUTE_GAME_MODES = "modes";
export const ROUTE_SETTINGS = "settings";
export const ROUTE_STATS = "stats";
